<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <div class="content">

          <!-- FILTER ROW -->


          <v-row class="g-4 mt-4 mb-8" dense>

            <!-- Transactions -->
            <v-col cols="12" md="12" class="ps-md-3">
              <div class="column-title mb-6">
                <h5 class="m-0 text-left">Recent Transactions</h5>
                <hr class="title-separator" />
              </div>

              <GlobalKyc />
              <v-row class="mb-4" dense>

                <!-- SEARCH -->
                <v-col cols="12" md="4">
                  <v-text-field v-model="filters.search" label="Search transactions" prepend-inner-icon="mdi-magnify"
                    variant="outlined" density="compact" hide-details />
                </v-col>

                <!-- FROM DATE -->
                <v-col cols="6" md="2">
                  <v-text-field v-model="filters.from" label="From" type="date" variant="outlined" density="compact"
                    hide-details />
                </v-col>

                <!-- TO DATE -->
                <v-col cols="6" md="2">
                  <v-text-field v-model="filters.to" label="To" type="date" variant="outlined" density="compact"
                    hide-details />
                </v-col>

                <!-- TYPE -->
                <v-col cols="6" md="2">
                  <v-select v-model="filters.type" :items="transactionTypes" label="Type" variant="outlined"
                    density="compact" hide-details clearable />
                </v-col>

                <!-- STATUS -->
                <v-col cols="6" md="2">
                  <v-select v-model="filters.status" :items="['successful', 'pending', 'failed']" label="Status"
                    variant="outlined" density="compact" hide-details clearable />
                </v-col>

              </v-row>

              <template v-if="loading">

                <v-col cols="12" v-for="n in 1" :key="n">
                  <v-card class="pa-6" rounded="lg">
                    <v-skeleton-loader type="heading" class="mb-4" />
                    <v-skeleton-loader type="text" />
                  </v-card>
                </v-col>

              </template>

              <!--Load Transactions-->
              <template v-else>
                <v-card class="outer-card chart-wrapper" style="border-radius: 8px;" flat>
                  <v-card class="pa-3 inner-transaction-card" flat>

                    <template v-for="(tx, index) in paginatedTransactions" :key="tx.uuid">

                      <!-- ROW -->
                      <div class="d-flex justify-space-between align-center py-2" @click="openTransaction(tx)">

                        <!-- LEFT SIDE -->
                        <div class="d-flex align-center">

                          <!-- Icon -->
                          <TransactionIcon :debit="isDebit(tx)" :size="28" />
                          <!-- <v-icon :color="isDebit(tx) ? 'red' : 'green'" size="28">
                          {{ isDebit(tx)
                            ? 'mdi-arrow-top-right-bold-box'
                            : 'mdi-arrow-bottom-left-bold-box'
                          }}
                        </v-icon> -->

                          <!-- Text -->
                          <div class="ms-3 text-left">
                            <div class="font-weight-medium text-body-2 text-capitalize">
                              {{ formatTitle(tx.type) }}
                            </div>

                            <div class="text-caption text-grey">
                              {{ tx.description }}
                            </div>

                          </div>

                        </div>

                        <!-- RIGHT SIDE -->
                        <div class="text-right">

                          <!-- Amount -->
                          <div class="font-weight-medium text-body-2" :class="isDebit(tx) ? 'text-red' : 'text-green'">
                            {{ isDebit(tx) ? '-' : '+' }}{{ formatCurrency(tx.amount) }}
                          </div>

                          <!-- Date -->
                          <div class="text-caption text-grey">
                            {{ formatDateTime(tx.created_at) }}
                          </div>
                          <div>
                            <span
                              :class="['status-pill', tx.status === 'successful' ? 'status-active' : 'status-inactive']">
                              {{ tx.status === 'successful' ? 'Successful' : 'Pending' }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Divider (only between items) -->
                      <v-divider v-if="index !== recentTransactions.length - 1" />

                    </template>

                  </v-card>

                </v-card>
              </template>
              <div class="d-flex justify-center mt-4">
                <v-pagination v-model="currentPage" :length="Math.ceil(filteredTransactions.length / perPage)"
                  total-visible="5" />
              </div>
            </v-col>
          </v-row>

          <!-- Transactio info Modal -->
          <v-dialog v-model="dialog" max-width="500">
            <v-card class="pa-5">

              <!-- HEADER (ICON + AMOUNT) -->
              <div class="text-center">

                <!-- <v-icon size="48" :color="isDebit(selectedTx) ? 'red' : 'green'">
                  {{ isDebit(selectedTx)
                    ? 'mdi-arrow-top-right-bold-box-outline'
                    : 'mdi-arrow-bottom-left-bold-box-outline'
                  }}
                </v-icon> -->
                <TransactionIcon :debit="isDebit(selectedTx)" :size="35" />

                <div class="text-h5 font-weight-bold mt-3" :class="isDebit(selectedTx) ? 'text-red' : 'text-green'">
                  {{ isDebit(selectedTx) ? '- ' : '+ ' }}{{ formatCurrency(selectedTx?.amount) }}
                </div>

                <div class="text-caption mt-1" :class="isDebit(selectedTx) ? 'text-red' : 'text-green'">
                  {{ formatTitle(selectedTx?.type) }}
                </div>

              </div>

              <!-- RECEIPT CARD -->
              <v-card class="mt-5 pa-4 inner-mini-card" variant="">

                <div v-for="(item, index) in receiptItems" :key="index">

                  <v-row class="pa-5 align-center">

                    <!-- LABEL -->
                    <v-col cols="5" class="text-caption text-grey">
                      {{ item.label }}
                    </v-col>

                    <!-- VALUE -->
                    <v-col cols="7" class="text-body-2 font-weight-medium text-right">
                      {{ item.value || 'N/A' }}
                    </v-col>

                  </v-row>

                  <!-- Divider -->
                  <v-divider v-if="index !== receiptItems.length - 1" />

                </div>

              </v-card>

              <!-- DOWNLOAD BUTTON -->
              <v-btn class="mt-5 theme-button" block @click="downloadPDF(selectedTx)">
                <!-- Download PDF
                <v-icon end>mdi-cloud-download-outline</v-icon> -->
                <span v-if="!downloading">Download PDF <v-icon end>mdi-cloud-download-outline</v-icon></span>
                <span v-else>Downloading <v-icon start class="spin">mdi-loading</v-icon></span>
              </v-btn>

              <!-- CLOSE -->
              <!-- <v-btn class="mt-2" block variant="text" @click="dialog = false">
                Close
              </v-btn> -->

            </v-card>
          </v-dialog>

          <!-- PDF Template -->
          <div ref="pdfRef" class="pdf-receipt">

            <div class="pdf-header">
              <img :src="logo" class="pdf-logo" />
              <h3>Transaction Receipt</h3>
            </div>

            <div class="pdf-amount">
              {{ isDebit(selectedTx) ? '- ' : '+ ' }}{{ formatCurrency(selectedTx?.amount) }}
            </div>

            <div class="pdf-body">
              <div class="pdf-row" v-for="(item, i) in receiptItems" :key="i">
                <span>{{ item.label }}</span>
                <span>{{ item.value }}</span>
              </div>
            </div>

            <div class="pdf-footer">
              <p>Powered by {{ company }}</p>
              <p class="text-green">{{ web }}</p>
              <p>{{ formatDateTime(new Date()) }}</p>
            </div>
          </div>



        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, reactive } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { useTransactStore } from "@/store/transaction"
import { formatCurrency, formatTitle, formatDateTime } from "@/util"
import { COMPANY, WEBSITE } from "@/api/env"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import logo from '@/assets/crowdital-icon.png'
import TransactionIcon from "@/components/icons/TransactionIcon.vue"
import GlobalKyc from "@/components/GlobalKyc.vue"

//piniastore
const trn = useTransactStore()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const currentPage = ref(1)
const perPage = ref(8)
const dialog = ref(false)
const selectedTx = ref(null)
const pdfRef = ref(null)
const downloading = ref(false)
const company = COMPANY
const web = WEBSITE
const loading = ref(true)

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  await trn.loadTransaction()
  loading.value = false
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

/* Transaction */

const transactions = computed(() => trn.transactions || [])

const filters = reactive({
  search: '',
  from: null,
  to: null,
  type: null,
  status: null,
  quick: null
})

const transactionTypes = [
  'debit',
  'credit',
  'investment',
  'withdrawal'
]

const recentTransactions = computed(() => {
  let data = transactions.value ?? []

  // SEARCH
  if (filters.search) {
    const q = filters.search.toLowerCase()

    data = data.filter(tx =>
      tx.description?.toLowerCase().includes(q) ||
      tx.type?.toLowerCase().includes(q) ||
      tx.transaction_id?.toLowerCase().includes(q) ||
      tx.status?.toLowerCase().includes(q) ||
      tx.reference?.toLowerCase().includes(q)
    )
  }

  // TYPE FILTER
  if (filters.type) {
    data = data.filter(tx => tx.type === filters.type)
  }

  // STATUS FILTER
  if (filters.status) {
    data = data.filter(tx => tx.status === filters.status)
  }

  // DATE RANGE (FROM)
  if (filters.from) {
    data = data.filter(tx =>
      new Date(tx.created_at) >= new Date(filters.from)
    )
  }

  // DATE RANGE (TO)
  if (filters.to) {
    data = data.filter(tx =>
      new Date(tx.created_at) <= new Date(filters.to)
    )
  }

  //return data.slice(0, 6)
  return data
})

const isDebit = (tx) => {
  if (!tx) return false
  return ['debit', 'investment', 'withdrawal'].includes(tx.type)
}

//filter
const applyFilters = (tx) => {
  if (filters.search) {
    const q = filters.search.toLowerCase()

    const match =
      tx.description?.toLowerCase().includes(q) ||
      tx.transaction_id?.toLowerCase().includes(q) ||
      tx.reference?.toLowerCase().includes(q)

    if (!match) return false
  }

  if (filters.type && tx.type !== filters.type) return false
  if (filters.status && tx.status !== filters.status) return false

  if (filters.from && new Date(tx.created_at) < new Date(filters.from)) return false
  if (filters.to && new Date(tx.created_at) > new Date(filters.to)) return false

  return true
}


const filteredTransactions = computed(() => {
  let data = transactions.value ?? []

  // apply your filters here (search, type, status, date range)
  return data.filter(applyFilters)
})

//pagination
const paginatedTransactions = computed(() => {
  const start = (currentPage.value - 1) * perPage.value
  const end = start + perPage.value

  return filteredTransactions.value.slice(start, end)
})

//open modal for transaction
const openTransaction = (tx) => {
  selectedTx.value = tx
  dialog.value = true
}

//Modal
const receiptItems = computed(() => {
  if (!selectedTx.value) return []

  return [
    { label: 'Transaction ID', value: selectedTx.value.transaction_id },
    { label: 'Type', value: formatTitle(selectedTx.value.type) },
    { label: 'Amount', value: formatCurrency(selectedTx.value.amount) },
    { label: 'Status', value: selectedTx.value.status },
    { label: 'Source', value: selectedTx.value.transaction_source },
    { label: 'Destination', value: selectedTx.value.transaction_destination },
    { label: 'Date', value: formatDateTime(selectedTx.value.created_at) },
    { label: 'Reference', value: selectedTx.value.reference }
  ]
})

//Download PDF

const downloadPDF = async (tx) => {
  if (!tx) return
  downloading.value = true
  await document.fonts.ready

  const element = pdfRef.value

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: false
  })

  const imgData = canvas.toDataURL("image/png")

  const pdf = new jsPDF("p", "mm", "a4")

  const pageWidth = 210
  const pageHeight = 297

  const imgHeight = (canvas.height * pageWidth) / canvas.width

  let heightLeft = imgHeight
  let position = 0

  pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight)

  heightLeft -= pageHeight

  while (heightLeft > 0) {
    position -= pageHeight
    pdf.addPage()
    pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight)
    heightLeft -= pageHeight
  }

  pdf.save(`transaction-${tx.transaction_id || "receipt"}.pdf`)
  downloading.value = false
}

</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

.content {
  padding-left: 10%;
  padding-right: 10%;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Table */
.modern-table {
  border: none;
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: #ecfdf5;
  color: #16a34a;
}

.status-inactive {
  background: #fef2f2;
  color: #dc2626;
}

/* Search input */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 8px;
  color: #64748b;
}

.search-wrapper input {
  padding-left: 28px;
}

/* Button */
.theme-button {
  height: 46px;
  background: #0f2638;
  color: #fff;
  border-radius: 6px;
  font-weight: 600;
  transition: all 0.25s ease;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

/* Column title */
.column-title h5 {
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
  border: none;
  height: 1px;
  background-color: #eae5e5;
  margin: 0;
  margin-bottom: 8px;
}

.inner-mini-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
}

.inner-transaction-card>div:hover {
  background: #f9f9f9;
  border-radius: 6px;
  cursor: pointer;
}

/*PDF Download */
.pdf-receipt {
  width: 600px;
  padding: 24px;
  background: #fff;
  font-family: Arial, sans-serif;
  position: absolute;
  left: -9999px;
  top: 0;
}

.pdf-header {
  text-align: center;
  margin-bottom: 20px;
}

.pdf-header h3 {
  color: #0f2638;
}

.pdf-logo {
  width: 120px;
  margin-bottom: 10px;
}

.pdf-amount {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;
}

.pdf-body {
  border-top: 1px solid #eee;
  margin-top: 10px;
}

.pdf-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.pdf-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #888;
}

.pdf-receipt {
  max-width: 100%;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .content {
    padding: 0;
  }

  .avatar-mobile {
    width: 32px;
    height: 32px;
  }

  .title-mobile {
    font-size: 0.9rem;
  }

  .icon-mobile {
    font-size: 16px;
  }
}
</style>
